<div>
  <form>
  <div class="twelve columns">
    <div class="row">
      <div *ngIf="pivotName" class="field">
        <p id="pivotName"
            class="lm-text-data hide-white-space"
            data-automation-id="lm-dimensions-pivot-name"
            [ngStyle]="{'display': 'inline-block'}"
            [class.data]="true"
        >{{labelPivotName}}</p>
      </div>
      <div class="field">
        <soho-swaplist id="dimensions" class="lm-swaplist-dims"
            [availableCardTitle]="labelAvailable"
            [selectedCardTitle]="labelSelected"
            [availableItems]="available"
            [selectedItems]="current"
            (beforeswap)="onBeforeSwap($event)"
            (updated)="onDimensionSwapListUpdated($event)">
        </soho-swaplist>
      </div>
    </div>
    <div class="row">
      <div *ngIf="hasDimensionLevels" class="field">
        <label soho-label for="levels-spinbox">{{labelLevels}}</label>
        <input soho-spinbox id="levels-spinbox" data-automation-id="lm-dimensions-levels-spinbox" name="levels-spinbox"
            soho-trackdirty (pristine)="onPristine($event)" (dirty)="onDirty($event)"
            min="0"
            [max]="maxLevels"
            [(ngModel)]="showLevels"/>
      </div>
      <div *ngIf="hasSuppressZeros" class="field">
        <input soho-checkbox type="checkbox" id="suppressZeros" name="suppressZeros" data-automation-id="lm-dimensions-suppress-zeros"
            soho-trackdirty (pristine)="onPristine($event)" (dirty)="onDirty($event)"
            [(ngModel)]="suppressZeros"/>
        <label soho-label for="suppressZeros" [forCheckBox]="true">{{labelSuppressZeros}}</label>
      </div>
      <div *ngIf="hasTotalNode" class="field">
        <input soho-checkbox type="checkbox" id="showTotal" name="showTotal" data-automation-id="lm-dimensions-show-total"
            soho-trackdirty (pristine)="onPristine($event)" (dirty)="onDirty($event)"
            [(ngModel)]="showTotal"/>
        <label soho-label for="showTotal" [forCheckBox]="true">{{labelShowTotal}}</label>
      </div>
      <div *ngIf = "hasSuppressCurPeriod" class="field">
        <input soho-checkbox type="checkbox" id="suppressCurPeriod" name="suppressCurPeriod" data-automation-id="lm-dimensions-suppress-cur-period"
            soho-trackdirty (pristine)="onPristine($event)" (dirty)="onDirty($event)"
            [(ngModel)]="suppressCurPeriod"/>
        <label soho-label for="suppressCurPeriod" [forCheckBox]="true">{{labelSuppressCurPeriod}}</label>
      </div>
      <div *ngIf = "showPreservePD" class="field">
        <input soho-checkbox type="checkbox" id="preservePD" name="preservePivotDim" data-automation-id="lm-dimensions-preserve-pivot"
            soho-trackdirty (pristine)="onPristine($event)" (dirty)="onDirty($event)"
            [(ngModel)]="preservePD"/>
        <label soho-label for="preservePD" [forCheckBox]="true">{{labelPreservePD}}</label>
      </div>
    </div>
  </div>
  </form>
</div>
